export const SMALL_STRING_LIMIT = 100;
